import { Pen, TriangleAlert } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { Button } from '~/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '~/components/ui/dialog'
import { InfosPersoForm } from '~/domains/account/components/personal-infos/infos-perso-form'
import { useUserContext } from '~/providers/user-provider'

const Error = () => {
	const { t } = useTranslation()

	return (
		<div className='flex min-w-0 flex-col items-center gap-1 text-center text-primary text-sm'>
			<TriangleAlert
				size={24}
				strokeWidth={1.5}
			/>

			{t('errors:user.persoInfosIncomplete')}
		</div>
	)
}

const PersoInfos = () => {
	const { userQuery } = useUserContext()

	const { first_name, last_name, email, phone } = userQuery.data || {}

	return (
		<div className='min-w-0 text-sm'>
			<div className='truncate font-bold'>
				{`${first_name || ''} ${last_name || ''}`}
			</div>

			<div className='truncate'>{email || ''}</div>

			<div className='truncate'>{phone || ''}</div>
		</div>
	)
}

export const PersoInfosRecap = ({
	readOnly = false,
}: {
	readOnly?: boolean
}) => {
	const { t } = useTranslation()
	const { isInfosPersoIncomplete } = useUserContext()
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div className='flex flex-col gap-1'>
			{isInfosPersoIncomplete ? <Error /> : <PersoInfos />}

			{!readOnly && (
				<div className='mt-auto flex flex-row print:hidden'>
					<Dialog
						open={isOpen}
						onOpenChange={setIsOpen}
					>
						<DialogTrigger asChild>
							<Button
								variant='link'
								size='sm'
								className='ml-auto'
							>
								<Pen
									size={14}
									className='mr-1'
								/>

								{t('actions:update.btnLabel')}
							</Button>
						</DialogTrigger>

						<DialogContent>
							<DialogHeader>
								<DialogTitle>{t('infosPersoForm:title')}</DialogTitle>
							</DialogHeader>

							<InfosPersoForm onSuccess={() => setIsOpen(false)} />
						</DialogContent>
					</Dialog>
				</div>
			)}
		</div>
	)
}
